require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// C:/WORK/Projects/ActNow_NG2/node_modules/core-js/modules/es6.array.species.js
// module id = ../../../../core-js/modules/es6.array.species.js
// module chunks = polyfills vendor